module.exports = __webpack_public_path__ + "img/rain_white.86f1e372.svg";